import React, { useRef, useState } from "react";

import {
    Box,
    Card,
    Typography,
    TextField,
    Button,
    Divider,
    IconButton,
    InputAdornment,
    Alert,
    MenuItem,
} from "@mui/material";

import {
    PhoneAndroidOutlined,
    LockOutlined,
    Visibility,
    VisibilityOff,
    PersonOutline,
    CheckCircleOutline,
    ArrowBack,
    ArrowForward,
    ShieldOutlined,
    VerifiedUserOutlined,
} from "@mui/icons-material";


const registrationSteps = [
    "Mobile",
    "OTP",
    "Personal Details",
    "Password",
    "TPIN",
];


const TAWalletRegistration = () => {

    const [currentStep, setCurrentStep] = useState(1);

    const [mobile, setMobile] = useState("");

    const [otp, setOtp] = useState([
        "",
        "",
        "",
        "",
        "",
        "",
    ]);

    const otpRefs = useRef([]);


    const [personalDetails, setPersonalDetails] =
        useState({
            firstName: "",
            lastName: "",
            identificationType: "",
            identificationNumber: "",
            email: "",
            dateOfBirth: "",
        });


    const [password, setPassword] =
        useState("");

    const [confirmPassword, setConfirmPassword] =
        useState("");

    const [showPassword, setShowPassword] =
        useState(false);

    const [showConfirmPassword, setShowConfirmPassword] =
        useState(false);


    const [tpin, setTpin] = useState([
        "",
        "",
        "",
        "",
    ]);

    const tpinRefs = useRef([]);


    const [loading, setLoading] =
        useState(false);

    const [errorMessage, setErrorMessage] =
        useState("");

    const [successMessage, setSuccessMessage] =
        useState("");


    // ==================================================
    // COMMON TEXT FIELD STYLE
    // ==================================================

    const textFieldStyles = {

        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",

            backgroundColor: "#ffffff",

            fontSize: 14,
        },

        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
        {
            borderColor: "#8cae9d",
        },

        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
        {
            borderColor: "#16834d",

            borderWidth: "1px",
        },

        "& .MuiInputLabel-root.Mui-focused": {
            color: "#16834d",
        },
    };


    // ==================================================
    // MOBILE
    // ==================================================

    const handleMobileChange = (event) => {

        const value =
            event.target.value.replace(/\D/g, "");

        if (value.length <= 10) {

            setMobile(value);

            setErrorMessage("");
        }
    };


    // ==================================================
    // SEND OTP
    // ==================================================

    const handleSendOtp = () => {

        if (mobile.length !== 10) {

            setErrorMessage(
                "Please enter a valid 10-digit mobile number."
            );

            return;
        }

        setErrorMessage("");

        setSuccessMessage("");

        setLoading(true);


        // Replace with your API

        setTimeout(() => {

            setLoading(false);

            setSuccessMessage(
                "OTP has been sent to your mobile number."
            );

            setCurrentStep(2);

        }, 800);
    };


    // ==================================================
    // OTP CHANGE
    // ==================================================

    const handleOtpChange = (
        index,
        value
    ) => {

        const numericValue =
            value.replace(/\D/g, "");

        const updatedOtp = [...otp];

        updatedOtp[index] =
            numericValue.charAt(
                numericValue.length - 1
            );

        setOtp(updatedOtp);

        setErrorMessage("");


        if (
            numericValue &&
            index < otp.length - 1
        ) {

            otpRefs.current[
                index + 1
            ]?.focus();
        }
    };


    // ==================================================
    // OTP BACKSPACE
    // ==================================================

    const handleOtpKeyDown = (
        index,
        event
    ) => {

        if (
            event.key === "Backspace" &&
            !otp[index] &&
            index > 0
        ) {

            otpRefs.current[
                index - 1
            ]?.focus();
        }
    };


    // ==================================================
    // VERIFY OTP
    // ==================================================

    const handleVerifyOtp = () => {

        const enteredOtp =
            otp.join("");

        if (enteredOtp.length !== 6) {

            setErrorMessage(
                "Please enter the 6-digit OTP."
            );

            return;
        }

        setErrorMessage("");

        setSuccessMessage("");

        setLoading(true);


        // Replace with OTP API

        setTimeout(() => {

            setLoading(false);

            setSuccessMessage(
                "Mobile number verified successfully."
            );

            setCurrentStep(3);

        }, 800);
    };


    // ==================================================
    // PERSONAL DETAILS
    // ==================================================

    const handlePersonalChange = (
        field,
        value
    ) => {

        setPersonalDetails(
            (previous) => ({
                ...previous,

                [field]: value,
            })
        );

        setErrorMessage("");
    };


    const handlePersonalSubmit = () => {

        if (
            !personalDetails.firstName.trim()
        ) {

            setErrorMessage(
                "Please enter your first name."
            );

            return;
        }


        if (
            !personalDetails.lastName.trim()
        ) {

            setErrorMessage(
                "Please enter your last name."
            );

            return;
        }


        if (
            !personalDetails.identificationType
        ) {

            setErrorMessage(
                "Please select an identification type."
            );

            return;
        }


        if (
            !personalDetails.identificationNumber.trim()
        ) {

            setErrorMessage(
                "Please enter your identification number."
            );

            return;
        }


        if (!personalDetails.dateOfBirth) {

            setErrorMessage(
                "Please enter your date of birth."
            );

            return;
        }


        setErrorMessage("");

        setCurrentStep(4);
    };


    // ==================================================
    // PASSWORD
    // ==================================================

    const handlePasswordSubmit = () => {

        if (!password) {

            setErrorMessage(
                "Please enter a password."
            );

            return;
        }


        if (password.length < 8) {

            setErrorMessage(
                "Password must contain at least 8 characters."
            );

            return;
        }


        if (password !== confirmPassword) {

            setErrorMessage(
                "Password and confirm password do not match."
            );

            return;
        }


        setErrorMessage("");

        setCurrentStep(5);
    };


    // ==================================================
    // TPIN
    // ==================================================

    const handleTpinChange = (
        index,
        value
    ) => {

        const numericValue =
            value.replace(/\D/g, "");

        const updatedTpin = [...tpin];

        updatedTpin[index] =
            numericValue.charAt(
                numericValue.length - 1
            );

        setTpin(updatedTpin);

        setErrorMessage("");


        if (
            numericValue &&
            index < tpin.length - 1
        ) {

            tpinRefs.current[
                index + 1
            ]?.focus();
        }
    };


    const handleTpinKeyDown = (
        index,
        event
    ) => {

        if (
            event.key === "Backspace" &&
            !tpin[index] &&
            index > 0
        ) {

            tpinRefs.current[
                index - 1
            ]?.focus();
        }
    };


    // ==================================================
    // CREATE ACCOUNT
    // ==================================================

    const handleCreateAccount = () => {

        if (tpin.join("").length !== 4) {

            setErrorMessage(
                "Please enter a 4-digit TPIN."
            );

            return;
        }

        setErrorMessage("");

        setLoading(true);


        // Replace with registration API

        setTimeout(() => {

            setLoading(false);

            setSuccessMessage(
                "Your TA Wallet account has been created successfully."
            );

            setCurrentStep(6);

        }, 1000);
    };


    // ==================================================
    // BACK
    // ==================================================

    const handleBack = () => {

        if (currentStep > 1) {

            setCurrentStep(
                currentStep - 1
            );

            setErrorMessage("");

            setSuccessMessage("");
        }
    };


    // ==================================================
    // PROGRESS
    // ==================================================

    const progress =
        currentStep >= 6
            ? 100
            : ((currentStep - 1) /
                4) *
            100;


    return (

        <Box
            sx={{
                minHeight: "100vh",

                backgroundColor: "#ffffff",

                display: "flex",

                justifyContent: "center",

                alignItems: "center",

                px: {
                    xs: 1.5,
                    sm: 3,
                    md: 4,
                },

                py: {
                    xs: 2,
                    sm: 4,
                    md: 5,
                },
            }}
        >

            {/* ==================================================
          SINGLE REGISTRATION CARD
      ================================================== */}

            <Card
                elevation={0}
                sx={{
                    width: "100%",

                    maxWidth: 920,

                    borderRadius: {
                        xs: "12px",
                        sm: "16px",
                    },

                    border:
                        "1px solid #dfe7e3",

                    backgroundColor:
                        "#ffffff",

                    boxShadow:
                        "0 10px 35px rgba(22,55,39,0.08)",

                    overflow: "hidden",

                    position: "relative",

                    "&::before": {
                        content: '""',

                        position: "absolute",

                        top: 0,
                        left: 0,
                        right: 0,

                        height: "3px",

                        backgroundColor: "#16834d",
                    },
                }}
            >

                {/* ==================================================
            CARD HEADER
        ================================================== */}

                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr 1.5fr 1fr",
                            sm: "1fr 2fr 1fr",
                        },
                        alignItems: "center",
                        width: "100%",
                        mb: { xs: 3, sm: 4 },
                        gap: { xs: 1, sm: 2 },
                        mt:3
                    }}
                >
                    {/* APSPDCL Logo */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            component="img"
                            src="/assets/apspdcl.jpg"
                            alt="APSPDCL Logo"
                            sx={{
                                height: {
                                    xs: 42,
                                    sm: 52,
                                    md: 60,
                                },
                                maxWidth: {
                                    xs: 110,
                                    sm: 150,
                                    md: 180,
                                },
                                width: "auto",
                                objectFit: "contain",
                            }}
                        />
                    </Box>

                    {/* Title */}
                    <Box
                        sx={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: {
                                    xs: 20,
                                    sm: 25,
                                    md: 29,
                                },
                                fontWeight: 700,
                                color: "#17221d",
                                lineHeight: 1.2,
                                whiteSpace: "nowrap",
                            }}
                        >
                            Pay Electricity Bill
                        </Typography>

                        <Typography
                            sx={{
                                mt: 0.8,
                                fontSize: {
                                    xs: 10.5,
                                    sm: 12,
                                    md: 13.5,
                                },
                                color: "#6d7772",
                                lineHeight: 1.4,
                                textAlign: "center",
                            }}
                        >
                            Verify your TA Wallet account and pay your electricity bill securely.
                        </Typography>
                    </Box>

                    {/* TA Wallet Logo */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            component="img"
                            src="/assets/ta_walletlogo.png"
                            alt="TA Wallet Logo"
                            sx={{
                                height: {
                                    xs: 34,
                                    sm: 42,
                                    md: 48,
                                },
                                maxWidth: {
                                    xs: 105,
                                    sm: 140,
                                    md: 165,
                                },
                                width: "auto",
                                objectFit: "contain",
                            }}
                        />
                    </Box>
                </Box>




                {/* ==================================================
            STEP PROGRESS
        ================================================== */}

                <Box
                    sx={{
                        px: {
                            xs: 1.5,
                            sm: 3,
                            md: 5,
                        },

                        py: 2.5,

                        backgroundColor: "#fbfcfb",
                    }}
                >

                    <Box
                        sx={{
                            display: "flex",

                            alignItems: "center",

                            width: "100%",
                        }}
                    >

                        {registrationSteps.map(
                            (step, index) => {

                                const stepNumber =
                                    index + 1;

                                const active =
                                    currentStep ===
                                    stepNumber;

                                const completed =
                                    currentStep >
                                    stepNumber;

                                return (

                                    <React.Fragment
                                        key={step}
                                    >

                                        <Box
                                            sx={{
                                                display: "flex",

                                                flexDirection:
                                                    "column",

                                                alignItems:
                                                    "center",

                                                minWidth: {
                                                    xs: 42,
                                                    sm: 75,
                                                },
                                            }}
                                        >

                                            <Box
                                                sx={{
                                                    width: {
                                                        xs: 29,
                                                        sm: 34,
                                                    },

                                                    height: {
                                                        xs: 29,
                                                        sm: 34,
                                                    },

                                                    borderRadius:
                                                        "50%",

                                                    display: "flex",

                                                    alignItems:
                                                        "center",

                                                    justifyContent:
                                                        "center",

                                                    backgroundColor:
                                                        active ||
                                                            completed
                                                            ? "#16834d"
                                                            : "#ffffff",

                                                    border:
                                                        active ||
                                                            completed
                                                            ? "1px solid #16834d"
                                                            : "1px solid #cbd5cf",

                                                    color:
                                                        active ||
                                                            completed
                                                            ? "#ffffff"
                                                            : "#87918c",

                                                    fontSize: 11,

                                                    fontWeight: 700,
                                                }}
                                            >

                                                {completed ? (
                                                    <CheckCircleOutline
                                                        sx={{
                                                            fontSize: 17,
                                                        }}
                                                    />
                                                ) : (
                                                    stepNumber
                                                )}

                                            </Box>


                                            <Typography
                                                sx={{
                                                    mt: 0.7,

                                                    fontSize: {
                                                        xs: 9,
                                                        sm: 11,
                                                    },

                                                    color:
                                                        active
                                                            ? "#16834d"
                                                            : "#7b8580",

                                                    fontWeight:
                                                        active
                                                            ? 600
                                                            : 400,

                                                    textAlign:
                                                        "center",
                                                }}
                                            >
                                                {step}
                                            </Typography>

                                        </Box>


                                        {index <
                                            registrationSteps.length -
                                            1 && (

                                                <Box
                                                    sx={{
                                                        flex: 1,

                                                        height: "1px",

                                                        backgroundColor:
                                                            currentStep >
                                                                stepNumber
                                                                ? "#16834d"
                                                                : "#d9e0dc",

                                                        mb: 2,
                                                    }}
                                                />

                                            )}

                                    </React.Fragment>
                                );
                            }
                        )}

                    </Box>
                </Box>


                <Box
                    sx={{
                        px: {
                            xs: 2,
                            sm: 4,
                            md: 7,
                        },

                        py: {
                            xs: 3,
                            sm: 4,
                            md: 2,
                        },
                    }}
                >

                    {/* ==================================================
              STEP 1 - MOBILE
          ================================================== */}

                    {currentStep === 1 && (

                        <Box>

                            <StepHeading
                                icon={
                                    <PhoneAndroidOutlined />
                                }

                                title="Verify your mobile number"

                                description="We'll send a one-time password to verify your mobile number and create your TA Wallet account."
                            />


                            <Box
                                sx={{
                                    maxWidth: 560,

                                    mx: "auto",

                                    mt: 3,
                                }}
                            >

                                <TextField
                                    fullWidth
                                    size="small"

                                    label="Mobile Number"

                                    placeholder="Enter 10-digit mobile number"

                                    value={mobile}

                                    onChange={
                                        handleMobileChange
                                    }

                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                +91
                                            </InputAdornment>
                                        ),
                                    }}

                                    sx={
                                        textFieldStyles
                                    }
                                />


                                <Button
                                    fullWidth

                                    variant="contained"

                                    onClick={
                                        handleSendOtp
                                    }

                                    disabled={
                                        mobile.length !== 10 ||
                                        loading
                                    }

                                    sx={{
                                        mt: 2,

                                        height: 42,

                                        borderRadius: "8px",

                                        backgroundColor:
                                            "#16834d",

                                        textTransform:
                                            "none",

                                        fontWeight: 600,

                                        boxShadow: "none",

                                        "&:hover": {
                                            backgroundColor:
                                                "#116b3f",

                                            boxShadow: "none",
                                        },
                                    }}
                                >
                                    {loading
                                        ? "Sending OTP..."
                                        : "Send OTP"}
                                </Button>

                            </Box>

                        </Box>

                    )}


                    {/* ==================================================
              STEP 2 - OTP
          ================================================== */}

                    {currentStep === 2 && (

                        <Box>

                            <StepHeading
                                icon={
                                    <VerifiedUserOutlined />
                                }

                                title="Verify OTP"

                                description={`Enter the 6-digit OTP sent to +91 ${mobile}.`}
                            />


                            <Box
                                sx={{
                                    display: "flex",

                                    justifyContent:
                                        "center",

                                    gap: {
                                        xs: 0.8,
                                        sm: 1.2,
                                    },

                                    mt: 3,
                                }}
                            >

                                {otp.map(
                                    (value, index) => (

                                        <TextField
                                            key={index}

                                            inputRef={(element) => {
                                                otpRefs.current[
                                                    index
                                                ] = element;
                                            }}

                                            value={value}

                                            onChange={(e) =>
                                                handleOtpChange(
                                                    index,
                                                    e.target.value
                                                )
                                            }

                                            onKeyDown={(e) =>
                                                handleOtpKeyDown(
                                                    index,
                                                    e
                                                )
                                            }

                                            inputProps={{
                                                maxLength: 1,

                                                inputMode:
                                                    "numeric",

                                                style: {
                                                    textAlign:
                                                        "center",

                                                    fontSize: 18,

                                                    fontWeight: 600,
                                                },
                                            }}

                                            sx={{
                                                width: {
                                                    xs: 42,
                                                    sm: 50,
                                                },

                                                "& .MuiOutlinedInput-root":
                                                {
                                                    borderRadius:
                                                        "8px",
                                                },

                                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                    borderColor:
                                                        "#16834d",
                                                },
                                            }}
                                        />

                                    )
                                )}

                            </Box>


                            <Box
                                sx={{
                                    maxWidth: 560,

                                    mx: "auto",

                                    mt: 3,
                                }}
                            >

                                <Button
                                    fullWidth

                                    variant="contained"

                                    onClick={
                                        handleVerifyOtp
                                    }

                                    disabled={loading}

                                    sx={{
                                        height: 42,

                                        borderRadius: "8px",

                                        backgroundColor:
                                            "#16834d",

                                        textTransform:
                                            "none",

                                        fontWeight: 600,

                                        boxShadow: "none",

                                        "&:hover": {
                                            backgroundColor:
                                                "#116b3f",
                                        },
                                    }}
                                >
                                    {loading
                                        ? "Verifying..."
                                        : "Verify OTP"}
                                </Button>


                                <Button
                                    fullWidth

                                    startIcon={
                                        <ArrowBack />
                                    }

                                    onClick={
                                        handleBack
                                    }

                                    sx={{
                                        mt: 1,

                                        color: "#68736e",

                                        textTransform:
                                            "none",
                                    }}
                                >
                                    Change Mobile Number
                                </Button>

                            </Box>

                        </Box>

                    )}


                    {/* ==================================================
              STEP 3 - PERSONAL DETAILS
          ================================================== */}

                    {currentStep === 3 && (

                        <Box>

                            <StepHeading
                                icon={
                                    <PersonOutline />
                                }

                                title="Personal details"

                                description="Enter your details to complete your TA Wallet profile."
                            />


                            <Box
                                sx={{
                                    maxWidth: 650,

                                    mx: "auto",

                                    mt: 3,
                                }}
                            >

                                <Box
                                    sx={{
                                        display: "grid",

                                        gridTemplateColumns: {
                                            xs: "1fr",
                                            sm: "1fr 1fr",
                                        },

                                        gap: 2,
                                    }}
                                >

                                    <TextField
                                        fullWidth
                                        size="small"

                                        label="First Name"

                                        value={
                                            personalDetails.firstName
                                        }

                                        onChange={(e) =>
                                            handlePersonalChange(
                                                "firstName",
                                                e.target.value
                                            )
                                        }

                                        sx={
                                            textFieldStyles
                                        }
                                    />


                                    <TextField
                                        fullWidth
                                        size="small"

                                        label="Last Name"

                                        value={
                                            personalDetails.lastName
                                        }

                                        onChange={(e) =>
                                            handlePersonalChange(
                                                "lastName",
                                                e.target.value
                                            )
                                        }

                                        sx={
                                            textFieldStyles
                                        }
                                    />


                                    <TextField
                                        select
                                        fullWidth
                                        size="small"

                                        label="Identification Type"

                                        value={
                                            personalDetails.identificationType
                                        }

                                        onChange={(e) =>
                                            handlePersonalChange(
                                                "identificationType",
                                                e.target.value
                                            )
                                        }

                                        sx={
                                            textFieldStyles
                                        }
                                    >

                                        <MenuItem value="Aadhaar">
                                            Aadhaar
                                        </MenuItem>

                                        <MenuItem value="PAN">
                                            PAN
                                        </MenuItem>

                                        <MenuItem value="Voter ID">
                                            Voter ID
                                        </MenuItem>

                                        <MenuItem value="Driving Licence">
                                            Driving Licence
                                        </MenuItem>

                                    </TextField>


                                    <TextField
                                        fullWidth
                                        size="small"

                                        label="Identification Number"

                                        value={
                                            personalDetails.identificationNumber
                                        }

                                        onChange={(e) =>
                                            handlePersonalChange(
                                                "identificationNumber",
                                                e.target.value
                                            )
                                        }

                                        sx={
                                            textFieldStyles
                                        }
                                    />


                                    <TextField
                                        fullWidth
                                        size="small"

                                        label="Email Address"

                                        type="email"

                                        value={
                                            personalDetails.email
                                        }

                                        onChange={(e) =>
                                            handlePersonalChange(
                                                "email",
                                                e.target.value
                                            )
                                        }

                                        sx={
                                            textFieldStyles
                                        }
                                    />


                                    <TextField
                                        fullWidth
                                        size="small"

                                        label="Date of Birth"

                                        type="date"

                                        value={
                                            personalDetails.dateOfBirth
                                        }

                                        onChange={(e) =>
                                            handlePersonalChange(
                                                "dateOfBirth",
                                                e.target.value
                                            )
                                        }

                                        InputLabelProps={{
                                            shrink: true,
                                        }}

                                        sx={
                                            textFieldStyles
                                        }
                                    />

                                </Box>


                                <NavigationButtons
                                    onBack={handleBack}

                                    onNext={
                                        handlePersonalSubmit
                                    }

                                    nextText="Continue"
                                />

                            </Box>

                        </Box>

                    )}


                    {/* ==================================================
              STEP 4 - PASSWORD
          ================================================== */}

                    {currentStep === 4 && (

                        <Box>

                            <StepHeading
                                icon={
                                    <LockOutlined />
                                }

                                title="Create your password"

                                description="Create a strong password to keep your TA Wallet account secure."
                            />


                            <Box
                                sx={{
                                    maxWidth: 560,

                                    mx: "auto",

                                    mt: 3,
                                }}
                            >

                                <TextField
                                    fullWidth
                                    size="small"

                                    label="Password"

                                    type={
                                        showPassword
                                            ? "text"
                                            : "password"
                                    }

                                    value={password}

                                    onChange={(e) =>
                                        setPassword(
                                            e.target.value
                                        )
                                    }

                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">

                                                <IconButton
                                                    onClick={() =>
                                                        setShowPassword(
                                                            !showPassword
                                                        )
                                                    }
                                                    edge="end"
                                                >
                                                    {showPassword ? (
                                                        <VisibilityOff />
                                                    ) : (
                                                        <Visibility />
                                                    )}
                                                </IconButton>

                                            </InputAdornment>
                                        ),
                                    }}

                                    sx={
                                        textFieldStyles
                                    }
                                />


                                <TextField
                                    fullWidth
                                    size="small"

                                    sx={{
                                        ...textFieldStyles,

                                        mt: 2,
                                    }}

                                    label="Confirm Password"

                                    type={
                                        showConfirmPassword
                                            ? "text"
                                            : "password"
                                    }

                                    value={
                                        confirmPassword
                                    }

                                    onChange={(e) =>
                                        setConfirmPassword(
                                            e.target.value
                                        )
                                    }

                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">

                                                <IconButton
                                                    onClick={() =>
                                                        setShowConfirmPassword(
                                                            !showConfirmPassword
                                                        )
                                                    }
                                                    edge="end"
                                                >
                                                    {showConfirmPassword ? (
                                                        <VisibilityOff />
                                                    ) : (
                                                        <Visibility />
                                                    )}
                                                </IconButton>

                                            </InputAdornment>
                                        ),
                                    }}
                                />


                                <NavigationButtons
                                    onBack={handleBack}

                                    onNext={
                                        handlePasswordSubmit
                                    }

                                    nextText="Continue"
                                />

                            </Box>

                        </Box>

                    )}


                    {/* ==================================================
              STEP 5 - TPIN
          ================================================== */}

                    {currentStep === 5 && (

                        <Box>

                            <StepHeading
                                icon={
                                    <ShieldOutlined />
                                }

                                title="Create your TPIN"

                                description="Set a 4-digit TPIN. You will use it to securely authorize transactions."
                            />


                            <Box
                                sx={{
                                    maxWidth: 560,

                                    mx: "auto",

                                    mt: 3,

                                    textAlign: "center",
                                }}
                            >

                                <Box
                                    sx={{
                                        display: "flex",

                                        justifyContent:
                                            "center",

                                        gap: 1.2,
                                    }}
                                >

                                    {tpin.map(
                                        (value, index) => (

                                            <TextField
                                                key={index}

                                                inputRef={(element) => {
                                                    tpinRefs.current[
                                                        index
                                                    ] = element;
                                                }}

                                                value={value}

                                                onChange={(e) =>
                                                    handleTpinChange(
                                                        index,
                                                        e.target.value
                                                    )
                                                }

                                                onKeyDown={(e) =>
                                                    handleTpinKeyDown(
                                                        index,
                                                        e
                                                    )
                                                }

                                                type="password"

                                                inputProps={{
                                                    maxLength: 1,

                                                    inputMode:
                                                        "numeric",

                                                    style: {
                                                        textAlign:
                                                            "center",

                                                        fontSize: 20,

                                                        fontWeight: 700,
                                                    },
                                                }}

                                                sx={{
                                                    width: {
                                                        xs: 50,
                                                        sm: 58,
                                                    },

                                                    "& .MuiOutlinedInput-root":
                                                    {
                                                        borderRadius:
                                                            "8px",
                                                    },

                                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor:
                                                            "#16834d",
                                                    },
                                                }}
                                            />

                                        )
                                    )}

                                </Box>


                                <Alert
                                    icon={
                                        <ShieldOutlined />
                                    }

                                    severity="info"

                                    sx={{
                                        mt: 3,

                                        textAlign: "left",

                                        borderRadius: "8px",

                                        backgroundColor:
                                            "#f5faf7",

                                        color: "#41604f",

                                        fontSize: 12.5,
                                    }}
                                >
                                    Never share your TPIN with anyone.
                                    TA Wallet will never ask you to disclose
                                    your TPIN.
                                </Alert>


                                <NavigationButtons
                                    onBack={handleBack}

                                    onNext={
                                        handleCreateAccount
                                    }

                                    nextText={
                                        loading
                                            ? "Creating..."
                                            : "Create Account"
                                    }

                                    disabled={loading}
                                />

                            </Box>

                        </Box>

                    )}


                    {/* ==================================================
              SUCCESS
          ================================================== */}

                    {currentStep === 6 && (

                        <Box
                            sx={{
                                textAlign: "center",

                                py: 3,
                            }}
                        >

                            <Box
                                sx={{
                                    width: 65,

                                    height: 65,

                                    borderRadius: "50%",

                                    backgroundColor:
                                        "#edf7f1",

                                    display: "flex",

                                    alignItems: "center",

                                    justifyContent: "center",

                                    mx: "auto",

                                    mb: 2,
                                }}
                            >

                                <CheckCircleOutline
                                    sx={{
                                        color: "#16834d",

                                        fontSize: 38,
                                    }}
                                />

                            </Box>


                            <Typography
                                sx={{
                                    fontSize: 22,

                                    fontWeight: 700,

                                    color: "#1c2822",
                                }}
                            >
                                Registration Successful
                            </Typography>


                            <Typography
                                sx={{
                                    fontSize: 13,

                                    color: "#737e79",

                                    mt: 1,

                                    maxWidth: 500,

                                    mx: "auto",

                                    lineHeight: 1.6,
                                }}
                            >
                                Your TA Wallet account has been created
                                successfully. You can now use your wallet
                                for secure bill payments.
                            </Typography>


                            <Button
                                variant="contained"

                                endIcon={
                                    <ArrowForward />
                                }

                                onClick={() =>
                                    window.location.href =
                                    "/ta-wallet-electricity"
                                }

                                sx={{
                                    mt: 3,

                                    height: 42,

                                    px: 3,

                                    borderRadius: "8px",

                                    backgroundColor:
                                        "#16834d",

                                    textTransform:
                                        "none",

                                    fontWeight: 600,

                                    boxShadow: "none",

                                    "&:hover": {
                                        backgroundColor:
                                            "#116b3f",

                                        boxShadow: "none",
                                    },
                                }}
                            >
                                Continue to Electricity Payment
                            </Button>

                        </Box>

                    )}


                    {/* ==================================================
              ERROR / SUCCESS MESSAGE
          ================================================== */}

                    {errorMessage && (
                        <Alert
                            severity="error"
                            sx={{
                                mt: 3,

                                borderRadius: "8px",

                                fontSize: 12.5,
                            }}
                        >
                            {errorMessage}
                        </Alert>
                    )}


                    {successMessage &&
                        currentStep !== 6 && (
                            <Alert
                                severity="success"

                                icon={
                                    <CheckCircleOutline
                                        fontSize="inherit"
                                    />
                                }

                                sx={{
                                    mt: 3,

                                    borderRadius: "8px",

                                    backgroundColor:
                                        "#eef8f2",

                                    color: "#17663d",

                                    border:
                                        "1px solid #cde8d8",

                                    fontSize: 12.5,
                                }}
                            >
                                {successMessage}
                            </Alert>
                        )}

                </Box>


                {/* ==================================================
            FOOTER
        ================================================== */}

                <Divider />

                <Box
                    sx={{
                        py: 1.8,

                        px: 2,

                        textAlign: "center",

                        backgroundColor: "#fcfdfc",
                    }}
                >

                    <Typography
                        sx={{
                            fontSize: 11.5,

                            color: "#89938e",
                        }}
                    >
                        Your registration details are securely
                        processed through TA Wallet.
                    </Typography>

                </Box>

            </Card>

        </Box>
    );
};


// ======================================================
// STEP HEADING
// ======================================================

const StepHeading = ({
    icon,
    title,
    description,
}) => {

    return (
        <Box
            sx={{
                maxWidth: 650,
                mx: "auto",
            }}
        >
            {/* Icon + Title in one row */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1.5,
                }}
            >
                {/* Icon */}
                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: "12px",
                        backgroundColor: "#edf7f1",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        color: "#16834d",
                        flexShrink: 0,
                    }}
                >
                    {React.cloneElement(icon, {
                        sx: {
                            fontSize: 25,
                            color: "#16834d",
                        },
                    })}
                </Box>

                {/* Title */}
                <Typography
                    sx={{
                        fontSize: {
                            xs: 19,
                            sm: 21,
                        },
                        fontWeight: 700,
                        color: "#1c2822",
                        lineHeight: 1.3,
                    }}
                >
                    {title}
                </Typography>
            </Box>

            {/* Description */}
            <Typography
                sx={{
                    fontSize: 13,
                    color: "#7a837f",
                    mt: 1.2,
                    maxWidth: 520,
                    mx: "auto",
                    lineHeight: 1.6,
                    textAlign: "center",
                }}
            >
                {description}
            </Typography>
        </Box>
    );
};


// ======================================================
// NAVIGATION BUTTONS
// ======================================================

const NavigationButtons = ({
    onBack,
    onNext,
    nextText,
    disabled = false,
}) => {

    return (

        <Box
            sx={{
                display: "flex",

                gap: 1.5,

                mt: 3,
            }}
        >

            <Button
                variant="outlined"

                startIcon={
                    <ArrowBack />
                }

                onClick={onBack}

                sx={{
                    flex: 1,

                    height: 42,

                    borderRadius: "8px",

                    borderColor: "#b9c6bf",

                    color: "#5e6963",

                    textTransform: "none",

                    fontWeight: 600,

                    "&:hover": {
                        borderColor: "#16834d",

                        backgroundColor: "#f5faf7",
                    },
                }}
            >
                Back
            </Button>


            <Button
                variant="contained"

                endIcon={
                    <ArrowForward />
                }

                onClick={onNext}

                disabled={disabled}

                sx={{
                    flex: 1,

                    height: 42,

                    borderRadius: "8px",

                    backgroundColor: "#16834d",

                    textTransform: "none",

                    fontWeight: 600,

                    boxShadow: "none",

                    "&:hover": {
                        backgroundColor: "#116b3f",

                        boxShadow: "none",
                    },
                }}
            >
                {nextText}
            </Button>

        </Box>
    );
};


export default TAWalletRegistration;